import React from "react";

import { useTranslation } from "react-i18next";

import { FormInputFieldCurrency } from "@components-shared/desktop/inputs";
import { LimitCategoryTypes } from "@data-types";
import { LIMITS_CONSTANTS } from "@services/account-settings/MyLimitsConstants";

export default function MonthlyDepositLimit(props: {
	type: LimitCategoryTypes;
}) {
	const { t } = useTranslation("my-limits");

	const label =
		props.type == LimitCategoryTypes.GAMES
			? "my-limits:MONTHLY_GAMES_DEPOSIT_LABEL"
			: "my-limits:MONTHLY_DEPOSIT_LABEL";

	const placeholder =
		props.type == LimitCategoryTypes.GAMES
			? "my-limits:MONTHLY_GAMES_DEPOSIT_PLACEHOLDER"
			: "my-limits:MONTHLY_DEPOSIT_PLACEHOLDER";

	const maxDepositLimitValue =
		props.type == LimitCategoryTypes.GAMES
			? LIMITS_CONSTANTS.GAMES_MAX_DEPOSIT
			: LIMITS_CONSTANTS.GENERAL_MAX_AMOUNT;

	return (
		<div className="form--grid__col col col-sml-12 col-med-12 col-lrg-12 col-xlrg-12 col--ssvga-6 col-hdlow-6 col-xxlrg-6 col-huge-6 col-xxxlrg-6">
			<FormInputFieldCurrency
				label={label}
				name="amount"
				type="number"
				step={".01"}
				className="form__field"
				placeholder={placeholder}
				validate={{
					isNotNegative: (value: string) =>
						Number(value) > 0 || t("ONE_OR_GREATER", { 0: 0 }),
					isMaxLengthReached: (value: string) =>
						Number(value) <= maxDepositLimitValue ||
						t("LIMIT_EXCEEDS_MAX_VALUE"),
				}}
				required
			/>
		</div>
	);
}
